/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getClient, getAllClients } from "../services/clintServices";

import { DateFormatter, alertMsg } from "../utilities/helper";
import { getReq } from "../services/APIMethods";


export const getAllBannars = createAsyncThunk(
  "banners/getAllBannars",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);


const initialState = {
  loading: false,
  success: true,
  error: null,
  banners_details: {},
  data: [],
};

//login service

const banners = createSlice({
  name: "banners",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get all
    builder.addCase(getAllBannars.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAllBannars.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
      state.success = action.payload.data.success;
    });
    builder.addCase(getAllBannars.rejected, (state, action) => {
      state.loading = false;
      state.success = action.payload.response.data.success;
      state.error = action.payload.response.data.error;
    });
    // get one
    builder.addCase(getClient.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getClient.fulfilled, (state, action) => {
      state.loading = false;
      state.banners_details = action.payload.data;
      state.success = action.payload.data.success;
    });
    builder.addCase(getClient.rejected, (state, action) => {
      state.loading = false;
      state.success = action.payload.response.data.success;
      state.error = action.payload.response.data.error;
    });
  },
});
export default banners.reducer;
